export const rounding = (num: number) => Math.round(num * 100) / 100;
